import { camelCase } from "lodash";
import { StatusValues } from "../ResourceStatus/ResourceStatus";
import { SearchResultsItem } from "./SearchContents";
import { ResultColumn } from "./SearchResults";
import { ResultsEntity } from "../../types/funnelback/Response";
import {
    getListMetadataField,
    getListMetadataFieldJoined,
    getResultFieldValue,
} from "../../utils/getListMetadataField";

const DEFAULT_METADATA_JOIN_WITH = ", ";

const formatSearchResults = (
    items: ResultsEntity[],
    columns: ResultColumn[]
): SearchResultsItem[] =>
    items.map((item): SearchResultsItem => {
        const formattedItem: Partial<SearchResultsItem> = {};
        columns.forEach((columnDef) => {
            const { funnelbackField, columnKey, metadataValue, metadataJoinWith } =
                columnDef;

            if (
                funnelbackField.startsWith("listMetadata.") &&
                metadataValue === "join"
            ) {
                const key = funnelbackField.slice("listMetadata.".length);
                formattedItem[columnKey] = getListMetadataFieldJoined(
                    item,
                    key,
                    metadataJoinWith ?? DEFAULT_METADATA_JOIN_WITH
                );
                return;
            }

            formattedItem[columnKey] = getResultFieldValue(
                item,
                funnelbackField
            ) as string;
        });

        const status = getListMetadataField(item, "status");
        if ("status" in formattedItem) {
            formattedItem.status = formattedItem?.status
                ? (camelCase(formattedItem.status) as StatusValues)
                : (camelCase(status) as StatusValues);
        }

        return formattedItem;
    });

export default formatSearchResults;
